import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface MfaStatusStore {
  /** True si el usuario está obligado a configurar 2FA y aún no lo tiene activo. */
  setupPendiente: boolean;
  /** ISO datetime hasta cuándo dura el periodo de gracia (null = sin grace). */
  graceUntil: string | null;
  /** Para que el redirect post-login solo ocurra una vez por sesión. */
  redirected: boolean;

  setStatus: (setupPendiente: boolean, graceUntil: string | null) => void;
  setRedirected: (v: boolean) => void;
  clear: () => void;
}

export const useMfaStatusStore = create<MfaStatusStore>()(
  persist(
    (set) => ({
      setupPendiente: false,
      graceUntil: null,
      redirected: false,

      setStatus: (setupPendiente, graceUntil) =>
        set({ setupPendiente, graceUntil, redirected: false }),
      setRedirected: (v) => set({ redirected: v }),
      clear: () =>
        set({ setupPendiente: false, graceUntil: null, redirected: false }),
    }),
    { name: 'mfa-status' }
  )
);

/** Devuelve milisegundos restantes hasta `graceUntil`. Negativo o NaN si no aplica. */
export const msHastaGrace = (graceUntil: string | null): number => {
  if (!graceUntil) return Number.NaN;
  return new Date(graceUntil).getTime() - Date.now();
};

export const UMBRAL_MODAL_BLOQUEANTE_MS = 24 * 60 * 60 * 1000; // 1 día
